import body from './body.glb'
import platform from './platform.glb'
import defaultBody from './defaultBody.glb'

export default {
    body,
    platform,
    defaultBody,
}
